// extracted by mini-css-extract-plugin
module.exports = {"card":"business_card__3QdV5","title":"business_title__2RBpf","wrapper":"business_wrapper__36XSx","paragraph":"business_paragraph__1gb9E"};